import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableWorkerList } from '../../Pages/Worker/WorkerList/LoadableWorkerList';
import { AppRoutes } from '../../../Core/App/AppRoutes';
import {LoadableWorkerDetails} from "../../Pages/Worker/WorkerDetails/LoadableWorkerDetails";

const getWorkerListRoute = (props: object): AppRouteType => ({
    id: AppRoutes.WORKER_LIST,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.WORKER_LIST,
        component: LoadableWorkerList,
        ...props,
    },
});

const getWorkerDetailsRoute = (props: object): AppRouteType => ({
    id: AppRoutes.WORKER_DETAILS,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.WORKER_DETAILS,
        component: LoadableWorkerDetails,
        ...props,
    }
})

export const getWorkerRoutes = (args: object) => [
    getWorkerListRoute(args),
    getWorkerDetailsRoute(args),
];
